import { render, staticRenderFns } from "./market-break-down-sales.page.vue?vue&type=template&id=6f1d8cf4&scoped=true"
import script from "./market-break-down-sales.page.vue?vue&type=script&lang=ts"
export * from "./market-break-down-sales.page.vue?vue&type=script&lang=ts"
import style0 from "./market-break-down-sales.page.vue?vue&type=style&index=0&id=6f1d8cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1d8cf4",
  null
  
)

export default component.exports